/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
 * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
 */
// tslint:disable
import { AsyncResult, callActionOrExecute, DataServiceQuery, IContext, IDataServiceRequest } from '@msdyn365-commerce/retail-proxy';
// @ts-ignore
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
import * as DataServiceEntities from './TryInStoreDataServiceEntities.g';

// @ts-ignore
function tryInStoresQuery(storeId?: string): DataServiceQuery {
    const key = storeId ? { StoreId: storeId } : null;
    return new DataServiceQuery('TryInStores', 'MFITryInStore', DataServiceEntities.MFITryInStoreExtensionClass, key);
}

export function createMFIGetTryInStoreInfoInput(tryInStoreProductIDs: DataServiceEntities.IMFITryInStore): IDataServiceRequest {
    const query = tryInStoresQuery();
    return query.createDataServiceRequestForOperation(
        'MFIGetTryInStoreInfo',
        true,
        DataServiceEntities.MFITryInStoreInfoResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IMFITryInStoreInfoResponse' },
        { tryInStoreProductIDs: tryInStoreProductIDs }
    );
}

export function mFIGetTryInStoreInfoAsync(
    context: IContext,
    tryInStoreProductIDs: DataServiceEntities.IMFITryInStore
): AsyncResult<DataServiceEntities.IMFITryInStoreInfoResponse> {
    const request = createMFIGetTryInStoreInfoInput(tryInStoreProductIDs);
    return callActionOrExecute<DataServiceEntities.IMFITryInStoreInfoResponse>(request, context.callerContext);
}
